
const styles = (theme) => ({
  totalCheckedItems: {
    position: 'absolute',
    left: 10,
    top: 2,
    cursor: 'pointer'
  },

  titleCheckbox: {
    position: 'absolute',
    left: 23,
    top: 20,
    cursor: 'pointer'
  },
  rowCheckbox: {
    cursor: 'pointer'
  }
})

export {
  styles
}
